import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const PipeDependencies = lazy(() =>
  import(/* webpackChunkName: "PipeDependencies" */ '../../components/survey_editor/pipes/PipeDependencies')
);

export default function PipeDependenciesComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <PipeDependencies {...props} />
    </Suspense>
  );
}
